module.exports = __webpack_public_path__ + "img/rack.84f45422.svg";